import styles from "./bulkSelector.module.scss";
import { MdRefresh } from "react-icons/md";
import Tooltip from "../Tooltip/Tooltip";

interface IProps {
  onSelect: (i: number) => void;
  onSelectAll?: () => void; // NEW: For filter-based selection
  onReset: () => void;
  selected: number | null;
  totalInFilter?: number; // NEW: Total leads matching current filter
  isFilterMode?: boolean; // NEW: Are we in filter-based selection mode?
  className?: any;
}

const BulkSelector = ({
  onSelect,
  onSelectAll,
  onReset,
  selected,
  totalInFilter,
  isFilterMode = false,
  className
}: IProps) => {
  return (
    <div className={`${styles.bulk_container} ${className}`}>
      <div className={styles.button_group}>
        <Tooltip content="Manually select the next 25 leads in the grid. Best for targeted bulk actions like Quick Share.">
          <button onClick={() => onSelect(25)}>Select next 25</button>
        </Tooltip>

        <Tooltip content="Manually select the next 50 leads in the grid. Useful for moderate bulk operations.">
          <button onClick={() => onSelect(50)}>Next 50</button>
        </Tooltip>

        {onSelectAll && totalInFilter !== undefined && (
          <Tooltip
            content={
              <span>
                Select <strong>all {totalInFilter} leads</strong> matching your current filters.{' '}
                <strong>Note:</strong> Some actions like Quick Share won't work with this option.
              </span>
            }
            maxWidth={280}
          >
            <button
              onClick={onSelectAll}
              className={isFilterMode ? styles.select_all_active : styles.select_all}
            >
              {isFilterMode ? (
                <>
                  <span style={{ marginRight: '4px' }}>✓</span>
                  All {totalInFilter}
                </>
              ) : (
                `Select All (${totalInFilter})`
              )}
            </button>
          </Tooltip>
        )}
      </div>
      {isFilterMode ? (
        <span className={styles.filter_mode_message}>
          <span style={{ fontSize: '16px' }}>ℹ️</span>
          All {totalInFilter} leads matching current filters will be affected
        </span>
      ) : selected ? (
        <span className={styles.selected_count}>
          {selected} leads selected
        </span>
      ) : null}

      <Tooltip content="Clear all selections and exit bulk selection mode">
        <button onClick={onReset} className={styles.reset_button}>
          <MdRefresh size={18} />
          Reset
        </button>
      </Tooltip>
    </div>
  );
};

export default BulkSelector;
